<ng-container *ngIf="data">

    <app-recap-info-general-acheteur [data]="data" [langue]="langue"></app-recap-info-general-acheteur>

</ng-container>




